import Button from 'react-bootstrap/Button'
import { ButtonLoader } from '../loader'

export default function SaveButton(props) {

    const { button_name, spinner, disabled } = props

    return (
        <>
            <Button type='submit' size='sm' className='submit_btn' disabled={spinner || disabled}>
                {spinner ?
                    <ButtonLoader />
                    :
                    button_name
                }
            </Button>
        </>
    )
}
